import React, {Component} from 'react';
import {Empty, Tabs} from "antd";
import {message} from "../sysManagement/utils/sysManagementUtils";
import ExtendedTree from "../components/extendedTree/ExtendedTree";
import {Scrollbars} from 'react-custom-scrollbars';
import request from "../../base/request";
import {getMediaTypeList} from "../mediaManage/actions/mediaAdminister";

const {TabPane} = Tabs;

class PowerEdit extends Component {

    roleId = this.props.roleId;
    mediaRoleObj;

    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            mediaPlatform: [],  //媒体类型List
            selectKey: 'webNews', //tab筛选
        }
    }

    componentDidMount() {
        this.initData();
        //媒体类型
        this.getMediaType();
    }

    /**
     * 媒体类型
     **/
    getMediaType() {
        getMediaTypeList({}, (data) => {
            let mediaPlatform = [];
            if (data && data.length > 0) {
                data.forEach(item => {
                    mediaPlatform.push({
                        "title": item.mediaTypeName,
                        "mediaTypeCode": item.mediaTypeCode,
                        "logoUrl": item.logoUrl
                    });
                });
            }
            this.setState({
                mediaPlatform
            });
        });
    }

    initData() {
        let params = {
            mediaRoleId: this.roleId,
            mediaType: this.state.selectKey
        }
        getEditRoleLimitsList(params, (data) => {
            if (data) {
                this.setState({
                    dataSource: data
                })
            }
        });
    }

    savePowerRole() {
        udpateMediaRoleItem(this.dataSource, (data) => {
            if (data) {
                message.success("保存成功");
            } else {
                message.error("保存失败");
            }
        });
    }

    dataSource = [];

    saveMediaRoleItem(data) {
        this.dataSource = data;
    }

    /**
     * tab切换
     */
    handleChange = key => {
        this.setState({
            selectKey: key
        }, () => {
            this.initData();
        });
    };

    render() {
        let width = "100%";
        return (
            <div>
                {
                    this.state.mediaPlatform && this.state.mediaPlatform.length > 0 ?
                        <Tabs tabBarGutter={20} activeKey={this.state.selectKey} onChange={this.handleChange}>
                            {this.state.mediaPlatform.map(item => {
                                return (
                                    <TabPane key={item.mediaTypeCode}
                                             tab={<span>{item.logoUrl ? <img src={item.logoUrl} style={{
                                                 width: "20px",
                                                 height: "20px",
                                                 objectFit: "cover",
                                                 borderRadius: "50%"
                                             }} alt=""/> : null}<span style={{
                                                 verticalAlign: "middle",
                                                 marginLeft: "5px"
                                             }}>{item.title}</span></span>}/>
                                )
                            })}
                        </Tabs> : null
                }
                {!this.state.dataSource.length ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/> :
                <Scrollbars autoHide autoHideTimeout={1} autoHideDuration={1} style={{width, height: 400}}>
                    <ExtendedTree
                        ref={(that) => this.websiteTree = that}
                        dataSource={this.state.dataSource}
                        firstColumnsName={'treeName'}
                        titleKeyList={[{key: 'show', titleName: '名称'}, {
                            key: 'edit',
                            titleName: '编辑'
                        }, {key: 'publish', titleName: '发布'}, {key: 'revert', titleName: '撤稿'}, {
                            key: 'delete',
                            titleName: '删除'
                        }]}
                        checkId={'id'}
                        childrenColumnName={'sons'}
                        selectAllData={(data) => {
                            this.saveMediaRoleItem(data);
                        }}
                    />
                </Scrollbars>}
            </div>
        );
    }
}

export default PowerEdit;

export const host = "/cm-sites-pms/";
export const Apis = {
    getEditRoleLimitsList: host + 'mediaRole/getAuth',
    udpateMediaRoleItem: host + 'mediaRole/editAuth',
};

export const udpateMediaRoleItem = (body, callBack) => {
    request({url: Apis.udpateMediaRoleItem, body, contentType: "json", method: 'post', callBack});
};
export const getEditRoleLimitsList = (body, callBack) => {
    request({url: Apis.getEditRoleLimitsList, body, callBack});
};